import Root from './src/Root';
import Page from './src/Page';
import './src/css/main.scss';

export const wrapPageElement = Page;

export const wrapRootElement = Root;
